<template>
    <div class="mt-1">
      <ValidationProvider v-if="condition"  :vid="validation_label" :name="validation_label" rules="" v-slot="{ errors }">
        <div class="upload-btn-wrapper">
          <button v-bind:class="{ btn_success: file || !errors[0], btn_danger: !file  && !!errors[0]  }" class="">Upload a file</button>
          <input accept=".doc, .jpg, .pdf, .jpeg, .png, .docx, .txt"  @change="fileUploader($event)" type="file" name="myfile" @click="$refs.fileInput.value=null" ref="fileInput"/>
        </div>
        <vs-chip @click="onClickFileRemove" closable v-if="(condition && file) || !!errors[0]" transparent :color="file || !errors[0] ? 'dark' : 'danger'"  class="mt-4">
          <a target="_blank" style="text-decoration: none; color: #000000" :href="file" >{{__nameSplitter(file)}}</a>
        </vs-chip>
        <span style="display: none">{{file}}</span>
      </ValidationProvider>
    </div>
</template>

<script>
  const SupplierRepository = RepositoryFactory.get('supplier');
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
      name: "file-uploader-not-required",
      props: {
        file: String,
        condition: {
          type: Boolean,
          default: null
        },
        required :{
          type: Boolean,
          default: true
        },
      },
    data() {
      return {
        validation_label: (Math.floor(Math.random() * 999999) + 1) + ' '
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    computed: {
      getRules: function () {
        return ''
      }
    },
      methods: {
        onClickFileRemove() {
          this.file = ''
          this.$emit('onClickFileRemove')
        },
        async fileUploader(event){
          this.$vs.loading();
          try {
            const file = await event.target.files[0]
            let formData = new FormData();
            formData.append('file', file);
            const file_name =  (await SupplierRepository.uploadFile(formData)).data.data.file
            this.file= file_name
            this.$emit('onSetFileName', file_name)
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

      }
  }
</script>

<style scoped>

</style>
